import { observable, action } from 'mobx'

//utils
import ScheduleRuleService from 'services/ScheduleRuleService';
import moment from 'moment';

//models
import ScheduleRule from 'models/ScheduleRule';

class ScheduleRuleStore {

  @observable scheduleRulesErrors = null

  @action
  createScheduleRule(data) {
    return ScheduleRuleService.createSchedule({ data }).then(res => {
              if (res.data.status === "Success") {
                return new ScheduleRule(res.data.data);
              } else {
                let { name, start_date, end_date, hour } = res.data.data;
                start_date = `${moment(start_date).format('YYYY-MM-DD')} ${hour}`;

                if (end_date === null) {
                  end_date = 'Sem fim';
                } else {
                  end_date = `${moment(end_date).format('YYYY-MM-DD')} ${hour}`;
                  end_date = moment(end_date).format('LLLL');
                }
                
                let error = {
                  title: 'Erro de Sobreposição',
                  message: `O horário não pode ser criado pois sobrepõe o horário "${name}"
                            que começa em: ${moment(start_date).format('LLLL')} e termina em: ${end_date}`
                }
                this.scheduleRulesErrors = error;
                return null;
              }
            })
  }

  @action
  deleteScheduleRule(data) {
    return ScheduleRuleService.deleteScheduleRule(data)
      .then(res => {
        console.log("Excluido com sucesso");
      })
      .catch(err => {throw err})
  }

  @action
  getSchedulePackages(pk_schedule_rule) {
    return ScheduleRuleService.getSchedulePackages({ pk_schedule_rule }).then(res => {
      if (res.data) {
        return res.data.map(p => p.pk_package)
      }
      return []
    });
  }

  @action
  editScheduleRule(data) {
    return ScheduleRuleService.editScheduleRule(data)
    .then(res => {
      if (res.data.status === "Success") {
        console.log("Editado com sucesso");
      } else {
        let { name, start_date, end_date, hour } = res.data.data;
        start_date = `${moment(start_date).format('YYYY-MM-DD')} ${hour}`;

        if (end_date === null) {
          end_date = 'Sem fim';
        } else {
          end_date = `${moment(end_date).format('YYYY-MM-DD')} ${hour}`;
          end_date = moment(end_date).format('LLLL');
        }
        
        let error = {
          title: 'Erro de Sobreposição',
          message: `O horário não pode ser criado pois sobrepõe o horário "${name}"
                    que começa em: ${moment(start_date).format('LLLL')} e termina em: ${end_date}`
        }
        this.scheduleRulesErrors = error;
      }
    })
    .catch(err => {throw err})
  }

  @action
  clearErrors() {
    this.scheduleRulesErrors = null;
  }
}
export default new ScheduleRuleStore();



// WEBPACK FOOTER //
// ./src/modules/schedule/ScheduleRuleStore.js